var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-3 pa-3 scrollable pre-formatted"},[_c('pre',{directives:[{name:"highlightjs",rawName:"v-highlightjs"}]},[_c('code',{staticClass:"cpp"},[_vm._v(_vm._s(_vm.code))])])])}
var staticRenderFns = []

export { render, staticRenderFns }